const gigSocialBoosts = [
	{
		path: '/jobs/gig-social-boosts/list',
		name: 'jobs-gig-social-boosts-list',
		component: () => import('@/views/jobs/gig-social-boosts/list.vue'),
		meta: { layout: 'content', module: 'MGJ,gigs' },
	},
]

export default gigSocialBoosts
